import {Payload} from '../../../../../../core/service/payload/payload';
import {Moment} from 'moment';
import {SaleCreateSimplePaymentPayload} from './saleCreateSimplePayment.payload';

export class SaleCreateSimplePaymentRequestPayload implements Payload {

    payment: SaleCreateSimplePaymentPayload;
    amount: number;
    label: string;
    deadline: Moment;
    onlinePayment: boolean;
    thirdPartyPartnerId: number;
    thirdPartyPaymentType: string;
    generateCommunication: boolean;
}
